export default "__VITE_ASSET__CtyJvQFp__"